import { render, staticRenderFns } from "./PeriodicalMap.vue?vue&type=template&id=dd8c432a&scoped=true"
import script from "./PeriodicalMap.vue?vue&type=script&lang=js"
export * from "./PeriodicalMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c432a",
  null
  
)

export default component.exports